import React from 'react'

interface SecuritySliderProps {
  value: string
  onChange: (value: string) => void
}

const levels = [
  { value: 'NONE', label: 'Sin seguridad', color: 'bg-gray-300' },
  { value: 'BASIC', label: 'Básica', color: 'bg-blue-400' },
  { value: 'MEDIUM', label: 'Media', color: 'bg-blue-500' },
  { value: 'ENHANCED', label: 'Mejorada', color: 'bg-blue-600' },
]

export const SecuritySlider = ({ value, onChange }: SecuritySliderProps) => {
  const currentIndex = levels.findIndex((l) => l.value === value)
  const safeIndex = currentIndex === -1 ? 0 : currentIndex

  const handleClick = (val: string) => {
    onChange(val)
  }

  return (
    <div className="w-full pt-4 pb-6 px-2">
      <div className="relative h-2 bg-gray-200 rounded-full w-[85%] mx-auto">
        {/* Filled Track */}
        <div
          className="absolute top-0 left-0 h-full bg-blue-600 rounded-full transition-all duration-300"
          style={{ width: `${(safeIndex / (levels.length - 1)) * 100}%` }}
        />

        {/* Dots */}
        {levels.map((level, index) => {
          const isActive = index <= safeIndex
          const isCurrent = index === safeIndex
          
          return (
            <div
              key={level.value}
              className="absolute top-1/2 -translate-y-1/2 cursor-pointer group"
              style={{ left: `${(index / (levels.length - 1)) * 100}%` }}
              onClick={() => handleClick(level.value)}
            >
              <div
                className={`w-4 h-4 rounded-full border-2 transition-all duration-300 ${
                  isActive ? 'border-blue-600 bg-white' : 'border-gray-300 bg-gray-100'
                } ${isCurrent ? 'scale-125 ring-4 ring-blue-100' : 'group-hover:scale-110'}`}
              >
                {isCurrent && <div className="w-2 h-2 bg-blue-600 rounded-full absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" />}
              </div>
              
              {/* Label */}
              <div 
                className={`absolute top-6 left-1/2 -translate-x-1/2 text-xs font-medium whitespace-nowrap transition-colors duration-300 ${
                  isCurrent ? 'text-blue-700' : 'text-gray-500'
                }`}
              >
                {level.label}
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
